// YOU MUST KEEP THIS IN SYNC WITH C# VERSION -- THIS HAS TO BE DONE MANUALLY.

// @dynamic
export class Regex {
    public static readonly ApiDate = /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/;
    public static readonly BreakTags = /(<|&lt;)br\s*\/*(>|&gt;)/g;
    // intentionally making following currency examples valid because our currency input component will format the number correctly for you
    // examples: '12.' and '12.1'
    public static readonly Currency = /^\d+\.?(\d{1,2})?$/;
    public static readonly DoubleSlash = /\/\//g;
    // the email Regexp below was taken from Angular's source
    public static readonly Email = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
    public static readonly Guid = /^[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}$/;
    public static readonly HtmlTag = /<[^>]*>/;
    public static readonly IsoDate = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/;
    public static readonly MultiSpace = /[\s]{2,}/;
    public static readonly Number = /\d/;
    public static readonly Password = /^.{8,}$/;
    // At least 8 characters, at least 1 of each: uppercase, lowercase, number, special character ([]{}()?"!@#%&/\,><':;|_!`)
    public static readonly StrictPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[$*.\[\]{}\(\)?"!@#%&\/\\,><':;|_~`]).{8,}$/;
    public static readonly SentenceCase = /([A-Z]+)*([A-Z][a-z])/;
    public static readonly ErrorCode = /^[45]/;
    public static readonly HttpSuccessOrRedirectCode = /^[23]/;
    public static readonly NonFloatCharacters = /[^\d.-]/g;
    public static readonly PathSegment = /[<>:"\/\\|?*\x00-\x1F]/;
    public static readonly alphaNumericOnly = /^[a-zA-Z0-9]*$/;
}
